import * as Chess from 'chess.js';

export function validateFen(fen) {
  try {
    const test = new Chess();
    return !!test.load(fen);
  } catch (_) {
    return false;
  }
}

export function fenFromPlacements({ whitePieces = [], blackPieces = [], sideToMove = 'w', castling = '-', ep = '-', halfmove = 0, fullmove = 1 }) {
  // whitePieces/blackPieces: [{ type: 'p|n|b|r|q|k', square: 'e4' }]
  const board = Array.from({ length: 8 }, () => Array(8).fill(''));
  const set = (piece, color, square) => {
    const file = square.charCodeAt(0) - 'a'.charCodeAt(0);
    const rank = parseInt(square[1], 10) - 1;
    const row = 7 - rank; // FEN ranks top to bottom
    board[row][file] = color === 'w' ? piece.toUpperCase() : piece;
  };
  whitePieces.forEach(p => set(p.type, 'w', p.square));
  blackPieces.forEach(p => set(p.type, 'b', p.square));
  const rows = board.map(row => {
    let fenRow = '';
    let empty = 0;
    row.forEach(cell => {
      if (!cell) empty++;
      else {
        if (empty) { fenRow += String(empty); empty = 0; }
        fenRow += cell;
      }
    });
    if (empty) fenRow += String(empty);
    return fenRow || '8';
  });
  return `${rows.join('/')}` + ` ${sideToMove} ${castling} ${ep} ${halfmove} ${fullmove}`;
}


